import Vue from 'vue';
import { AppFeature } from '@/modules/core/app/constants/app.constants';
import { getters } from '@/modules/core/app/helpers/store';
import { fromSnakeCaseToPascalCase } from '@/modules/core/app/helpers/StringHelper';

Object.keys(AppFeature).forEach((key) => {
  const globalInstanceMethod = `$is${fromSnakeCaseToPascalCase(AppFeature[key])}FeatureAvailable`;
  Vue.prototype[globalInstanceMethod] = () =>
    getters.session.getUserSettings()?.isFeatureAvailable(AppFeature[key]);
});
